import type { ReactNode } from "react";

export function renderMarkdown(value: string): ReactNode[] {
  const lines = value.split("\n");
  return lines.map((line, lineIndex) => {
    const parts = line.split(/(\*\*[^*]+\*\*|`[^`]+`|\[[^\]]+\]\([^\s)]+\))/g);
    return (
      <span key={`line-${lineIndex}`}>
        {parts.map((part, partIndex) => {
          if (part.startsWith("**") && part.endsWith("**")) {
            return <strong key={`strong-${partIndex}`}>{part.slice(2, -2)}</strong>;
          }
          if (part.startsWith("`") && part.endsWith("`")) {
            return <code key={`code-${partIndex}`} className="rounded bg-muted px-1 py-0.5 text-[0.9em]">{part.slice(1, -1)}</code>;
          }
          const link = part.match(/^\[([^\]]+)\]\(([^\s)]+)\)$/);
          if (link) {
            const [, label, href] = link;
            if (href.startsWith("https://")) {
              return <a key={`link-${partIndex}`} href={href} target="_blank" rel="noreferrer" className="underline">{label}</a>;
            }
          }
          return <span key={`text-${partIndex}`}>{part}</span>;
        })}
        {lineIndex < lines.length - 1 && <br />}
      </span>
    );
  });
}
